"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _window = _interopRequireDefault(require("global/window"));
var _browserDetection = _interopRequireDefault(require("../common/browser-detection"));
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
/* globals MediaStream */

var _BrowserDetection = (0, _browserDetection.default)(),
  isBrowser = _BrowserDetection.isBrowser;
var MediaUtil = {};
MediaUtil.createPeerConnection = function (turnServerInfo) {
  var config = {
    iceServers: []
  };
  if (turnServerInfo) {
    config.iceServers.push({
      urls: turnServerInfo.url,
      username: turnServerInfo.username || '',
      credential: turnServerInfo.password || ''
    });
  }
  if (isBrowser('firefox')) {
    config.bundlePolicy = 'max-compat';
  }
  return new _window.default.RTCPeerConnection(config);
};
MediaUtil.createMediaStream = function (tracks) {
  if (!tracks) {
    _loggerProxy.default.logger.error("Media:util#createMediaStream --> Tracks don't exist");
  }
  var filtredTracks = tracks.filter(function (element) {
    return !!element;
  });
  return new MediaStream(filtredTracks);
};
var _default = MediaUtil;
exports.default = _default;
//# sourceMappingURL=util.js.map
